import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="lg:w-1/2">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-snug">
              What Is <span className="text-primary-600">Kakobuy Spreadsheet</span>?
            </h2>
            <p className="mt-6 text-foreground-700 leading-relaxed text-sm md:text-base max-w-lg">
              The Kakobuy Spreadsheet is a meticulously curated product discovery database designed for savvy online shoppers. It aggregates thousands of verified product finds across multiple categories — from sneakers and streetwear to electronics and beauty products — all organized into one accessible, easy-to-navigate resource.
            </p>
            <p className="mt-4 text-foreground-600 leading-relaxed text-sm md:text-base max-w-lg">
              Instead of spending hours searching through scattered listings, the Kakobuy Spreadsheet gives you a handpicked selection of the best products, complete with pricing information, quality ratings, and direct links. Our community of experienced shoppers continuously updates the database to ensure freshness and accuracy.
            </p>

            <div className="mt-8 flex flex-wrap gap-8">
              <div>
                <span className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">14+</span>
                <p className="text-foreground-500 text-sm mt-1">Product Categories</p>
              </div>
              <div>
                <span className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">10K+</span>
                <p className="text-foreground-500 text-sm mt-1">Verified Finds</p>
              </div>
            </div>

            <Link
              to="/kakobuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Read Full Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>

          <div className="lg:w-1/2 w-full">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimal%20workspace%20scene%20with%20laptop%20displaying%20spreadsheet%20data%20surrounded%20by%20curated%20fashion%20accessories%20like%20sneakers%20perfume%20bottles%20jewelry%20and%20small%20bags%20on%20a%20warm%20wooden%20desk%20soft%20natural%20daylight%20from%20window%20aesthetic%20lifestyle%20photography%20neutral%20cream%20and%20warm%20sand%20tones%20editorial%20quality%20cozy%20vibe&width=800&height=600&seq=about-kakobuy-v3&orientation=landscape"
                alt="Kakobuy Spreadsheet organized product database"
                className="w-full h-auto object-cover rounded-2xl"
                loading="lazy"
              />
              <div className="absolute top-4 left-4">
                <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-800 text-xs font-semibold">
                  Community Verified
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-6">
                <p className="text-background-50 text-sm font-medium">Daily Updated</p>
                <p className="text-background-100/80 text-xs mt-0.5">Trusted by Shoppers Worldwide</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}